export var Status;
(function (Status) {
    Status["Success"] = "Success";
    Status["Failed"] = "Failed";
    Status["Error"] = "Error";
})(Status || (Status = {}));
//# sourceMappingURL=index.js.map